"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassCollectionsPaydownAllocationMethod = exports.ClassCurePaydownAllocationMethod = exports.ClassDrawRequestAllocationMethod = exports.FundingRequestComponentSettlementMethod = exports.FundingRequestGeneralPropertiesType = void 0;
__exportStar(require("./Shared/SharedFundingRequest"), exports);
var FundingRequestGeneralPropertiesType;
(function (FundingRequestGeneralPropertiesType) {
    FundingRequestGeneralPropertiesType["Properties"] = "properties";
})(FundingRequestGeneralPropertiesType = exports.FundingRequestGeneralPropertiesType || (exports.FundingRequestGeneralPropertiesType = {}));
var FundingRequestComponentSettlementMethod;
(function (FundingRequestComponentSettlementMethod) {
    FundingRequestComponentSettlementMethod["AutoSettle"] = "autoSettle";
    FundingRequestComponentSettlementMethod["Admin"] = "admin";
    FundingRequestComponentSettlementMethod["Api"] = "api";
})(FundingRequestComponentSettlementMethod = exports.FundingRequestComponentSettlementMethod || (exports.FundingRequestComponentSettlementMethod = {}));
var ClassDrawRequestAllocationMethod;
(function (ClassDrawRequestAllocationMethod) {
    ClassDrawRequestAllocationMethod["FixedAttachmentRateLimitProportion"] = "fixedAttachmentRateLimitProportion";
    ClassDrawRequestAllocationMethod["Cascade"] = "cascade";
})(ClassDrawRequestAllocationMethod = exports.ClassDrawRequestAllocationMethod || (exports.ClassDrawRequestAllocationMethod = {}));
var ClassCurePaydownAllocationMethod;
(function (ClassCurePaydownAllocationMethod) {
    ClassCurePaydownAllocationMethod["FixedAttachmentRateLimitProportion"] = "fixedAttachmentRateLimitProportion";
    ClassCurePaydownAllocationMethod["Cascade"] = "cascade";
})(ClassCurePaydownAllocationMethod = exports.ClassCurePaydownAllocationMethod || (exports.ClassCurePaydownAllocationMethod = {}));
var ClassCollectionsPaydownAllocationMethod;
(function (ClassCollectionsPaydownAllocationMethod) {
    ClassCollectionsPaydownAllocationMethod["FixedAttachmentRateLimitProportion"] = "fixedAttachmentRateLimitProportion";
    ClassCollectionsPaydownAllocationMethod["Empty"] = "empty";
})(ClassCollectionsPaydownAllocationMethod = exports.ClassCollectionsPaydownAllocationMethod || (exports.ClassCollectionsPaydownAllocationMethod = {}));
//# sourceMappingURL=FundingRequest.js.map